/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HTTPValidationError, WhistleblowerPolicyRequest, WhistleblowerReportRequest } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Whistleblower<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags whistleblower
   * @name AnalyzeReportWhistleblowerReportAnalyzePost
   * @summary Analyze Report
   * @request POST:/whistleblower/report/analyze
   */
  analyzeReportWhistleblowerReportAnalyzePost = (data: WhistleblowerReportRequest, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/whistleblower/report/analyze`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags whistleblower
   * @name DraftPolicyWhistleblowerPolicyDraftPost
   * @summary Draft Policy
   * @request POST:/whistleblower/policy/draft
   */
  draftPolicyWhistleblowerPolicyDraftPost = (data: WhistleblowerPolicyRequest, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/whistleblower/policy/draft`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
